import React from "react";
import { Container } from "@material-ui/core";
import under from "../../../images/images.png";

export default function Messages() {
  return (
    <Container
      style={{
        position: "fixed",
        height: "100%",
        paddingLeft: "0px",
        paddingRight: "0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img src={under} alt='under' height={"40%"} />
    </Container>
  );
}
